import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Guanxiwang"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.03676 3.71053C7.03676 4.03332 6.96772 4.33995 6.84363 4.6164L9.5958 6.82278C10.4938 5.92413 11.7336 5.36842 13.1029 5.36842C15.8441 5.36842 18.0662 7.59522 18.0662 10.3421C18.0662 11.5941 17.6045 12.7381 16.8425 13.6124L18.5213 15.4477C18.7203 15.3628 18.9392 15.3158 19.1691 15.3158C20.0828 15.3158 20.8235 16.0581 20.8235 16.9737C20.8235 17.8893 20.0828 18.6316 19.1691 18.6316C18.2554 18.6316 17.5147 17.8893 17.5147 16.9737C17.5147 16.6921 17.5848 16.4269 17.7084 16.1946L16.0297 14.3595C15.2091 14.9608 14.1974 15.3158 13.1029 15.3158C10.3618 15.3158 8.13971 13.089 8.13971 10.3421C8.13971 9.36517 8.42078 8.45402 8.9063 7.68544L6.15429 5.4792C5.78564 5.75665 5.32742 5.92105 4.83088 5.92105C3.61261 5.92105 2.625 4.93137 2.625 3.71053C2.625 2.48969 3.61261 1.5 4.83088 1.5C6.04916 1.5 7.03676 2.48969 7.03676 3.71053Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.1689 5.92105C20.3872 5.92105 21.3748 4.93137 21.3748 3.71053C21.3748 2.48969 20.3872 1.5 19.1689 1.5C17.9506 1.5 16.963 2.48969 16.963 3.71053C16.963 4.15484 17.0938 4.56854 17.319 4.91505L16.0295 6.32476C16.3273 6.54304 16.6 6.79379 16.8423 7.07181L18.1319 5.66204C18.441 5.82735 18.7941 5.92105 19.1689 5.92105ZM9.66842 13.9328C9.93382 14.1878 10.2274 14.4135 10.5441 14.6048L8.01283 17.9219C8.43518 18.4074 8.69098 19.0422 8.69098 19.7368C8.69098 21.2629 7.45647 22.5 5.93362 22.5C4.41078 22.5 3.17627 21.2629 3.17627 19.7368C3.17627 18.2108 4.41078 16.9737 5.93362 16.9737C6.36509 16.9737 6.77341 17.073 7.13706 17.25L9.66842 13.9328Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var guanxiwang = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { guanxiwang as default };
